import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { BlendEvent, DirtyOutKeyItemShareKey, FileItem, MOVE_ACTION_STEP, PathAddApiOutput, PathListApiOutput, WebpathActionType } from 'src/app/shared/models';
import { BlendService } from 'src/app/shared/services/blend.service';
import { NotificationsService } from 'src/app/core/notifications.service';
import { IBatchAction, IBatchActionView, IFile, INameData } from 'src/sync';
import { BatchMoveService } from 'src/app/shared/services/batch-move.service';
import { DirPickerService } from 'src/app/shared/services/dir-picker.service';
import { ConflictData, IDuplicateNameMap, IFileConflict } from 'src/app/shared/models/move.model';
import { FileListService } from '../../services/file-list.service';
import { SyncCryptService } from 'src/app/core/crypt/sync-crypt.service';
import { DirtyOutService } from 'src/app/core/crypt/dirty-out.service';
import { MoveActionsService } from 'src/app/shared/services/move-actions.service';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Button } from '@material-library';
import { BatchCopyService } from 'src/app/shared/services/batch-copy.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-move-dialog',
  templateUrl: './move-dialog.component.html',
  styleUrls: ['./move-dialog.component.scss']
})
export class MoveDialogComponent implements OnInit, OnDestroy {
  @Input() showMoveDialog!: boolean;
  @Input() selectedRows: FileItem[] = [];
  @Output() showMoveDialogChange = new EventEmitter<boolean>();
  @Input() actionMoveOrCopy: WebpathActionType = WebpathActionType.MOVE;
  @Input() public parentDir: IFile | PathListApiOutput;
  @Output() destinationSyncIdChange : EventEmitter<number> = new EventEmitter<number>();
  @Input() defaultTab: 'Files' | 'Vault' = 'Files';
  @Input() autoMove?: boolean = false;
  @Input() isProcessingJoin: boolean = false;


  duplicateNameMap: IDuplicateNameMap = {};
  public cancelButton: string = '';
  public actionButton: string = '';
  public teritaryButtonConfig?: Button;
  public subTitle = ''
  public decryptedName: string = '';
  private batchType: IBatchAction;
  public itemList: IFile[] = [];
  public transferQueue: IFileConflict[] = [];
  public conflictQueue: IFileConflict[] = [];

  public showTransferDialog: boolean = false;
  public actionStep: MOVE_ACTION_STEP = MOVE_ACTION_STEP.SELECT_DESTINATION_FOLDER;
  public closeButtonType: 'filled' | 'outlined' | 'flat' = 'flat';
  public activeButtonType: 'filled' | 'outlined' | 'flat' = 'filled';
  public conflictFileName: string = '';
  public conflictTotalCount: number = 0;
  public applyFixForTotalItemCount: number = 0;
  public moveActionStep: typeof MOVE_ACTION_STEP = MOVE_ACTION_STEP;
  isActionButtonLoading: boolean = false;
  conflictData: ConflictData | null;
  applyConflictForAll: boolean = false;
  selectedDirPathList: IFile[] = [];
  public batchView: IBatchActionView;
  sharedata?: DirtyOutKeyItemShareKey[];
  public dialogCloseConfirmationMsg = 'Are you sure you want to cancel?';
  public isSmallScreen: boolean;
  public newFolderName: string = '';
  public closeIconName: "close" | "arrow-left" = 'close';
  public title: string = '';
  public cwd: FileItem;
  public opennewFolderDialog: boolean = false;
  syncPid!: number;
  public hasNameConflict: boolean = false;
  public skipShareFolders = 0;
  public openRootFlag = false;
  private destroySubscriptions$ = new Subject<void>();
  public selectedPathListData: FileItem[] = [];
  public isLoadingDialog: boolean = false;  
  public open: boolean = false; 
  public tertiaryButtonAlignCenter = false;

  constructor(
    private blendService: BlendService,
    private batchMoveService: BatchMoveService,
    public dirPickerService: DirPickerService,
    private fileListService: FileListService,
    protected syncCryptService: SyncCryptService,
    private dirtyOutService: DirtyOutService,
    private moveActionsService: MoveActionsService,
    private batchCopyService: BatchCopyService,
    public breakpointObserver: BreakpointObserver,
  ) { }

  protected initCount = 2;
  async ngOnInit() {
    this.isLoadingDialog = true;
    this.open = true;
    this.batchMoveService.init();
    this.dirPickerService.init(this.dirPickerService.INIT_ALL);
    const mode = this.skipShareFolders ? this.dirPickerService.INIT_SKIPSHARE : this.dirPickerService.INIT_ALL;
    this.dirPickerService.init(mode);

    if (this.parentDir) {
      if (!this.autoMove) {
        const pathData = this.parentDir as PathListApiOutput;
        this.dirPickerService.view.parentList = pathData.parents;
        this.dirPickerService.view.dirlist = <IFile[]>this.dirPickerService.processList(pathData);
      
        // Only select if cwd is available
        if (pathData.cwd) {
          this.dirPickerService.select(pathData.cwd);
        }
      } else {
        this.dirPickerService.select(this.parentDir as IFile);
      }
      --this.initCount;
      this.checkLoadingState();
    }
    else {
      let inited;
      this.fileListService.getCwdSubscription()
      .pipe(takeUntil(this.destroySubscriptions$))
      .subscribe(async (data) => {
        if (data) {
          this.cwd = data;
          if (!inited) {
            await this.dirPickerService.cd(data.sync_id);
            this.dirPickerService.select(data);
          }
        } else {
          this.openRootFlag = true;
        }
        --this.initCount;
        this.checkLoadingState();
        inited = true;
      });
    }

    this.actionStep = this.actionMoveOrCopy === WebpathActionType.JOINSHARE ? MOVE_ACTION_STEP.JOIN_SHARE : MOVE_ACTION_STEP.SELECT_DESTINATION_FOLDER;

    this.itemList = [...this.selectedRows];
    this.batchType = this.actionMoveOrCopy == WebpathActionType.COPY ? this.batchCopyService : this.batchMoveService;
    this.batchView = this.batchType.view;
    if (this.actionMoveOrCopy == WebpathActionType.MOVE) {
      this.blendService.track(BlendEvent.BUTTON_CLICKED, {
        button_text: 'Move',
        num_items: this.selectedRows.length
      });
    }
    this.dialogConfig();
    this.breakpointObserver.observe([
      '(max-width: 599px)',
    ])
      .pipe(takeUntil(this.destroySubscriptions$))
      .subscribe((state: BreakpointState) => {
        if (state.breakpoints['(max-width: 599px)']) {
          this.isSmallScreen = true;
          this.dialogConfig();
        } else {
          this.isSmallScreen = false;
          this.dialogConfig();
        }
      });

      --this.initCount;
      this.checkLoadingState();
      
      if (this.autoMove) {
        this.onActionButtonClick();
      }    
  }
  closeMoveDialog = () => { 
    this.open = false;
    this.showMoveDialog = false;
    setTimeout(() => {
      this.isLoadingDialog = false;
      this.actionStep = MOVE_ACTION_STEP.BLANK;
      this.showMoveDialogChange.emit(this.showMoveDialog);
    }, 10)
  }
  private checkLoadingState() {
    if (this.initCount === 0) {
      this.open = false;
      setTimeout(() => {
        this.isLoadingDialog = false;
      }, 10); 
    }
  }
  ngOnDestroy(): void {
    this.actionStep = MOVE_ACTION_STEP.BLANK;
    this.destroySubscriptions$.next();
    this.destroySubscriptions$.complete();
    this.closeDialog();
  }
  closeDialog = () => {
    this.showMoveDialog = false;
    // this.batchType.view.globalCancel = true;
    setTimeout(() => {
      this.actionStep = MOVE_ACTION_STEP.BLANK;
      this.showMoveDialogChange.emit(this.showMoveDialog);
    }, 50)
  }

  openTransferDialog = () => {
    this.showTransferDialog = true;
  }
  closeTransferDialog = () => {
    this.showTransferDialog = false;
  }

  getDuplicateNameCheck = async (): Promise<boolean> => {
    this.conflictData = null;
    this.selectedDirPathList = [];
    this.sharedata = undefined;
    this.duplicateNameMap = {};
    this.conflictData = {};
    this.conflictQueue = [];
    const { count, conflictQueue, conflictData, conflictFileName } = await this.moveActionsService.getDuplicateNameCheck(this.dirPickerService.view.selected.sync_id, this.itemList)
    this.conflictData = conflictData;
    this.conflictQueue = conflictQueue;
    this.conflictFileName = conflictFileName;

    if (count == 1) {
      this.actionStep = MOVE_ACTION_STEP.ONE_CONFLICT;
    }
    if (count > 1) {
      this.actionStep = MOVE_ACTION_STEP.MANY_CONFLICT;
      this.conflictTotalCount = count;
      this.applyFixForTotalItemCount = count;
    }
    return !!count
  }

  onMove = async () => {
    if (!this.dirPickerService.view.selected || !this.itemList.length) return;
    this.isActionButtonLoading = true;
    try {

      if (await this.getDuplicateNameCheck()) {
        return;
      } else {
        this.actionStep = MOVE_ACTION_STEP.TRANSFER;
      }
      this.setTransferList(this.itemList);

    } catch (error) {
      console.error(error);
    } finally {
      this.dialogConfig();
      this.isActionButtonLoading = false;
    }
  }

  handleDestinationData(data: FileItem[]) {
    this.selectedPathListData = data;
  }
  

  setTransferList = (data: IFile[]) => {
    this.transferQueue = [...data];
    if (this.transferQueue.length) {
      this.actionStep = MOVE_ACTION_STEP.TRANSFER;
    } else {
      this.closeDialog()
    }
    this.isActionButtonLoading = false;
  }

  keepBoth = async (item: IFile) => {
    this.duplicateNameMap = await this.moveActionsService.keepBoth(item, this.dirPickerService.view.selected.sync_id, this.itemList, this.selectedDirPathList, this.duplicateNameMap);
  }

  onNameConflictsChange = (isNameConflict: boolean) => {
   this.hasNameConflict = isNameConflict;
  }

  dialogConfig = () => {
    this.subTitle = '';
    this.closeButtonType = 'flat';
    this.teritaryButtonConfig = undefined;
    this.title = this.actionMoveOrCopy;
    this.closeIconName = 'close';
    this.tertiaryButtonAlignCenter = false;
    switch (this.actionStep) {
      case MOVE_ACTION_STEP.SELECT_DESTINATION_FOLDER:
        this.subTitle = this.selectedRows.length === 1 ? `"${this.selectedRows[0].name}"` : this.selectedRows.length > 1 ? `${this.selectedRows.length} items` : '';
        this.cancelButton = 'Cancel';
        this.actionButton = this.actionMoveOrCopy;
        this.teritaryButtonConfig = {
          label: this.isSmallScreen ? '' : 'New folder',
          color: 'default',
          type: 'flat',
          leadAdornment: true,
          leadIconAdornment: 'add-new-folder',
          disabled: this.isActionButtonLoading,
          onClick: () => {
            this.actionStep = MOVE_ACTION_STEP.NEW_FOLDER;
            this.opennewFolderDialog = true;
            this.dialogConfig();
          }
        }
        break;
      case MOVE_ACTION_STEP.TRANSFER:
        this.cancelButton = 'Cancel';
        this.actionButton = '';

        break;
      case MOVE_ACTION_STEP.ONE_CONFLICT:
        this.actionButton = `Don't ${this.actionMoveOrCopy.toLowerCase()} item`;
        this.cancelButton = 'Keep both';
        this.activeButtonType = 'filled';
        this.closeButtonType = 'outlined';
        this.tertiaryButtonAlignCenter = true;
        this.teritaryButtonConfig = {
          label: 'Replace',
          color: 'default',
          type: 'outlined',
          leadAdornment: false,
          leadIconAdornment: 'add-new-folder',
          onClick: this.replaceAll
        }
        break;
      case MOVE_ACTION_STEP.MANY_CONFLICT:
        const cancelText = this.actionMoveOrCopy === WebpathActionType.MOVE ? 'moving' : 'copying';
        this.cancelButton = 'Cancel ' + cancelText;
        this.closeButtonType = 'outlined';
        this.actionButton = this.actionMoveOrCopy === WebpathActionType.MOVE ? 'Fix issues' : 'Review issues';
        break;
      case MOVE_ACTION_STEP.FIX_CONFLICT:
        this.actionButton = this.actionMoveOrCopy === WebpathActionType.MOVE ? `Don't move item` : 'Skip this item';
        this.cancelButton = 'Keep both';
        this.closeButtonType = 'outlined';
        this.tertiaryButtonAlignCenter = true;
        this.teritaryButtonConfig = {
          label: 'Replace',
          color: 'default',
          type: 'outlined',
          leadAdornment: false,
          leadIconAdornment: 'add-new-folder',
          onClick: async ()=>{
            await this.doneWithConflict();
            this.actionStep = MOVE_ACTION_STEP.TRANSFER;
            // this.replaceAll();
          }

        }
        break;
      case MOVE_ACTION_STEP.NEW_FOLDER:
        this.title = 'New folder'
        this.cancelButton = 'Cancel',
        this.actionButton = 'Create';
        this.closeIconName = 'arrow-left';
        this.closeButtonType = 'flat';
        break;
      case MOVE_ACTION_STEP.JOIN_SHARE:
        this.title = 'Choose destination folder';
        this.cancelButton = 'Cancel',
        this.actionButton = this.actionMoveOrCopy;
        break;
      default:
        break;
    }
  };

  getFixConflictItem = (): IFileConflict | undefined => {
    const item = this.conflictQueue.find((item) => item.isConflict && !item.isFixConflictActionTaken);
    if (item) {
      return item;
    } else {
    }
    return undefined
  }

  markKeepBothOrDontKeep = (keepBoth: boolean, applyToRestAll: boolean = false): boolean => {
    const conflictFileItem = this.getFixConflictItem();
    if (!conflictFileItem) return false;
    conflictFileItem.isFixConflictActionTaken = true;
    if (keepBoth) {
      conflictFileItem.canDuplicate = true;
      conflictFileItem.isSkipTransfer = false;
    } else {
      conflictFileItem.isSkipTransfer = true;
      conflictFileItem.canDuplicate = false;
    }
    (applyToRestAll && this.markKeepBothOrDontKeep(keepBoth, applyToRestAll));
    return true;
  }

  getConflictTransferList = (): IFileConflict[] => {
    const conflictFlagItem: IFileConflict[] = [];
    for (const item of this.conflictQueue) {
      if (!item?.isSkipTransfer) {
        conflictFlagItem.push(item);
      }
    }
    return conflictFlagItem
  }

  doneWithConflict = async () => {
    this.isActionButtonLoading = true;
    const eventItems: Promise<any>[] = []
    this.conflictQueue.forEach((item: IFileConflict) => {
      if (item.isConflict && item.canDuplicate) {
        eventItems.push(this.keepBoth(item));
      }
    })
    await Promise.all(eventItems);
    const items = this.getConflictTransferList();
    this.setTransferList(items);
  }

  onActionButtonClick = async () => {
    if(this.isActionButtonLoading)return;
    if (this.actionMoveOrCopy === WebpathActionType.JOINSHARE) {
      this.blendService.track(BlendEvent.BUTTON_CLICKED, {
        button_text: 'Save and join'
      });
    }
    this.isActionButtonLoading = true;
    let conflictFileItem: IFileConflict;

    switch (this.actionStep) {
      case MOVE_ACTION_STEP.SELECT_DESTINATION_FOLDER:
        this.onMove()
        break;
      case MOVE_ACTION_STEP.ONE_CONFLICT:
        this.markKeepBothOrDontKeep(false);
        this.setTransferList(this.getConflictTransferList());
        break;
      case MOVE_ACTION_STEP.MANY_CONFLICT:
        conflictFileItem = this.getFixConflictItem();
        if (conflictFileItem) {
          this.conflictFileName = conflictFileItem.name
          this.actionStep = MOVE_ACTION_STEP.FIX_CONFLICT
        }
        this.isActionButtonLoading = false;
        break;
      case MOVE_ACTION_STEP.FIX_CONFLICT:
        //Don't move item may conflict
        this.applyFixForTotalItemCount--;
        this.markKeepBothOrDontKeep(false, this.applyConflictForAll);
        conflictFileItem = this.getFixConflictItem();
        if (conflictFileItem) {
          this.conflictFileName = conflictFileItem?.name;
        } else {
          await this.doneWithConflict();
          this.actionStep = MOVE_ACTION_STEP.TRANSFER;
        }
        this.isActionButtonLoading = false;
        break;
      case MOVE_ACTION_STEP.NEW_FOLDER:
        this.createFolder()
        this.isActionButtonLoading = false;
        break;
      case MOVE_ACTION_STEP.JOIN_SHARE:
        this.blendService.track(BlendEvent.JOINED_SHARE);
        this.destinationSyncIdChange.emit(this.dirPickerService.view.selected.sync_id);
        break;

      default:
        break;
    }
    this.dialogConfig();
  }

  onCancelButtonClick = async () => {
    if(this.isActionButtonLoading)return;
    let conflictFileItem: IFileConflict;
    switch (this.actionStep) {
      case MOVE_ACTION_STEP.SELECT_DESTINATION_FOLDER:
        this.closeDialog()
        break;
      case MOVE_ACTION_STEP.TRANSFER:
        const c = window.confirm(this.dialogCloseConfirmationMsg);
        if (c) {
          this.batchType.view.globalCancel = true;
          this.batchType.cancel();
          this.closeDialog();
        }
        break;
      case MOVE_ACTION_STEP.ONE_CONFLICT:
          //Keep both action will update file name.
          const item = this.conflictQueue.find((item) => item.name === this.conflictFileName);
          if (item) {
            await this.keepBoth(item);
          }
          this.setTransferList(this.itemList);
          break;
      case MOVE_ACTION_STEP.MANY_CONFLICT:
        this.closeDialog();
        break;
      case MOVE_ACTION_STEP.FIX_CONFLICT:
        this.applyFixForTotalItemCount--;
        this.markKeepBothOrDontKeep(true, this.applyConflictForAll);
        conflictFileItem = this.getFixConflictItem();
        if (conflictFileItem) {
          this.conflictFileName = conflictFileItem?.name;
        } else {
          await this.doneWithConflict();
          this.actionStep = MOVE_ACTION_STEP.TRANSFER;
        }
        this.isActionButtonLoading = false;
        break;
      case MOVE_ACTION_STEP.NEW_FOLDER:
        this.closeDialog();
        break;
      case MOVE_ACTION_STEP.JOIN_SHARE:
        this.blendService.track(BlendEvent.BUTTON_CLICKED, {
          button_text: 'Cancel (joining share)'
        });
        this.closeDialog();
        break;
      default:
        break;
    }
    this.dialogConfig();
  }
  newFolderNameChange(name: string) {
    this.newFolderName = name;
  }
  createFolder = async () => {
    try {
      if (!this.newFolderName) {
        return;
      }
      this.isActionButtonLoading = true;
      const syncPid: number = this.dirPickerService.view?.selected?.sync_id ?? this.dirPickerService.view.cwd.sync_id;
      const result: PathAddApiOutput = await this.fileListService.mkdir(syncPid, this.newFolderName);
      this.fileListService.reload();
      this.gotoSelectDir();
      this.isActionButtonLoading = false;
    } catch (err) { }
  }
  gotoSelectDir = () => {
    if (this.actionStep !== MOVE_ACTION_STEP.NEW_FOLDER) {
      this.closeDialog();
    }
    this.selectedRows = [...this.itemList]
    this.actionStep = MOVE_ACTION_STEP.SELECT_DESTINATION_FOLDER;
    this.dialogConfig();
  }

  public disableExecute = (): boolean => {
    return (
      this.batchView.spinner > 0 ||
      !this.dirPickerService.view.selected ||
      !this.dirPickerService.getSelected?.sync_id ||
      (this.actionMoveOrCopy === WebpathActionType.JOINSHARE && this.hasNameConflict) ||
      (this.itemList.length > 0 && this.dirPickerService.view.selected.sync_id === (this.itemList[0].pid || this.itemList[0].sync_pid) && this.actionMoveOrCopy === WebpathActionType.MOVE)
    );
  }

  dialogNewFolderCreated = async (result: FileItem) => {
    if (result) {
      await this.dirPickerService.cd(result.sync_id);
      this.dirPickerService.select(result);
    }
    this.selectedRows = [...this.itemList];
    this.actionStep = MOVE_ACTION_STEP.SELECT_DESTINATION_FOLDER;
    this.dialogConfig();  
  }

  dialogNewFolderChange = (event: boolean) => {

  }

  replaceAll = async () => {
    this.setTransferList(this.itemList);
    this.dialogConfig()
  }
}
